(function ($) {

    $.fn.elegantBox = function (options) {
        var elBox = new ElegantBox(this, options);

        return this;
    };

    function ElegantBox(selector, options) {
        this.album = [];
        this.image = null;
        this.preloader = null;
        this.viewPortHeight = 0;
        this.viewPortWidth = 0;
        this.currentImageIndex = 0;
        this.mouseIsInside = null;
        this.elegantImage = $("<img class='elegant-image'>");

        this.options = $.extend({}, this.constructor.defaults);
        this.option(options);

        this.init($(selector));
    }

    ElegantBox.defaults = {
        version: '1.0',
        changePath: false,
        callback: function () { }
    };

    //Maybe in future some options will be added
    ElegantBox.prototype.option = function (options) {
        $.extend(this.options, options);
    };

    ElegantBox.prototype.addToAlbum = function (selector) {
        var self = this;

        function Images(src, className, title) {
            this.src = src;
            this.className = className;
            this.title = title;
        }

        if (self.album.length < 1 && typeof selector === 'object') {
            var title = null;
            var path = null;

            $(selector).find('li').each(function (indx, el) {
                if ($(this).find('.elegant-popup').attr('title')) {
                    title = $(this).find('.elegant-popup').attr('title');
                }

                if (self.options.changePath) {
                    path = $(this).find('.elegant-popup').parent('a').attr('rel');
                } else {
                    path = $(this).find('.elegant-popup').attr('src');
                }

                self.album.push(new Images(
                    path,
                    $(this).find('.elegant-popup').attr('class'),
                    title
                ));
            });
        }
        if (self.options.callback) {
            self.options.callback();
        }
        return false;
    };

    ElegantBox.prototype.build = function (e, selectedImage, selector) {
        var self = this;

        //create base wrapper
        $('body').css({ 'position': 'relative', 'overflow': 'hidden' })
            .prepend('<div class=\"elegant-wrapper\"><div class=\"elegant-inner\"/></div>');

        $('.elegant-wrapper').css({
            height: $(document).height()
        });

        self.viewPortHeight = parseFloat($(window).height()) - $(window).height() * 0.1;
        self.viewPortWidth = parseFloat($(window).width());

        $('.elegant-inner').css({
            'top': $(document).scrollTop() + (($(window).height() - self.viewPortHeight) / 2),
            'maxWidth': self.viewPortWidth + 'px',
            'maxHeight': self.viewPortHeight + 'px',
            'height': self.viewPortHeight + 'px'
        });


        self.getImageSize(selectedImage, function (width, height) {
            var offsetTop = self.getBodyOffset();

            self.image = $("<img class='elegant-image'>")
                .attr('src', self.preloader.src)
                .attr('title', selectedImage.attr('title'))
                .css({
                    'maxWidth': self.viewPortWidth + 'px',
                    'maxHeight': self.viewPortHeight + 'px',
                    'height': height + 'px',
                    'marginTop': offsetTop + 'px'
                })
                .appendTo('.elegant-inner');

            //create close button
            var closeButton = $("<button  class='elegant-close'>x</button>")
                .css({
                    'top': $(document).scrollTop(),
                    'marginTop': offsetTop + 'px'
                })
                .appendTo('.elegant-wrapper');
        });
    };

    ElegantBox.prototype.getImageSize = function (img, callback) {
        var self = this;

        self.preloader = new Image();
        self.preloader.onload = function () {
            if (typeof callback !== 'function') {
                alert('callback is not a function!');
            }

            self.preloader.height = this.height;
            self.preloader.width = this.width;

            callback(self.preloader.width, self.preloader.height);

            //create nav buttons
            self.appendNavArrows();
            self.appendCaption();
        };

        //TODO: Change this replace method to more generic solution
        self.preloader.src = img.attr('src').replace('Medium', 'Large').replace('Small', 'Large');
    };

    ElegantBox.prototype.appendCaption = function () {

        var titleAttr = null;
        if ($('.elegant-image').attr('title') !== undefined) {
            titleAttr = $('.elegant-image').attr('title');
        } else {
            titleAttr = null;
        }

        var topOffset = this.getBodyOffset();

        if (typeof titleAttr !== typeof undefined) {
            var textPositionCSS = {
                'top': $('.elegant-image').height() - 25 + topOffset + 'px',
                'width': $('.elegant-image').width() + 'px'
            };

            var imageDescription = $('<div class=\"elegant-caption\">' + titleAttr + '</div>')
                .css(textPositionCSS).appendTo('.elegant-inner');
        }
    };

    ElegantBox.prototype.updateCaption = function () {

        var titleAttr = null;
        if ($('.elegant-image').attr('title')) {
            titleAttr = $('.elegant-image').attr('title');
        }
        else {
            titleAttr = null;
        }

        var topOffset = this.getBodyOffset();

        if (titleAttr != null) {
            var captionCSS = {
                'top': $('.elegant-image').height() - 25 + topOffset + 'px',
                'width': $('.elegant-image').width() + 'px'
            };

            if ($('.elegant-caption')) {
                $('.elegant-caption').html(titleAttr);
            }
            else {
                var imageDescription = $('<div class=\"elegant-caption\">' + titleAttr + '</div>')
                    .css(captionCSS).appendTo('.elegant-inner');
            }
        }
        else {
            $('.elegant-caption').css('display', 'none').html('');
        }
    };

    ElegantBox.prototype.getBodyOffset = function () {
        var offsetTop = 0;

        if ($('body').css('marginTop')) {
            offsetTop += $('body').css('marginTop').replace('px', '');
        }

        if ($('body').css('top')) {
            offsetTop += $('body').css('top').replace('px', '');
        }
        offsetTop = offsetTop <= 0 ? offsetTop : -offsetTop;
        return offsetTop;
    }

    ElegantBox.prototype.appendNavArrows = function () {
        var self = this;
        var offsetTop = self.getBodyOffset();

        var navMarginTop = { 'marginTop': ($('.elegant-image').height() / 2) + parseInt(offsetTop) + 'px' };

        var navLeft = $('<a class="elegant-left-nav"><</a>')
            .css(navMarginTop).css('right', -(self.viewPortWidth / 2 - $('.elegant-image').width() / 2) + 'px');
        navLeft.appendTo('.elegant-inner');

        var navRight = $('<a class="elegant-right-nav">></a>')
            .css(navMarginTop).css('left', self.viewPortWidth / 2 - 50 + $('.elegant-image').width() / 2 + 'px');
        navRight.appendTo('.elegant-inner');
    };

    ElegantBox.prototype.updateArrowPosition = function () {
        var self = this;
        var offsetTop = self.getBodyOffset();

        var navMarginTop = { 'marginTop': ($('.elegant-image').height() / 2) + parseInt(offsetTop) + 'px' };

        $('.elegant-left-nav')
            .css(navMarginTop)
            .css('right', -(self.viewPortWidth / 2 - $('.elegant-image').width() / 2) + 'px');

        $('.elegant-right-nav')
            .css(navMarginTop)
            .css('left', self.viewPortWidth / 2 - 50 + $('.elegant-image').width() / 2 + 'px');

    };

    ElegantBox.prototype.preloadNeighboringImage = function (albumIndex) {
        var self = this;

        self.preloader.onload = function () {
            self.preloader.height = this.height;
            self.preloader.width = this.width;
            self.updateArrowPosition();
            self.updateCaption();
        };
        self.preloader.src = self.album[self.currentImageIndex].src;

        $('.elegant-image')
            .attr('src', self.preloader.src)
            .attr('title', self.album[self.currentImageIndex].title);
        return false;
    };

    ElegantBox.prototype.popupLeftNav = function (e) {
        e = e || window.event;

        if (this.currentImageIndex < 1)
            this.currentImageIndex = this.album.length - 1;
        else
            this.currentImageIndex = this.currentImageIndex - 1;

        this.preloadNeighboringImage(this.currentImageIndex);
        return false;
    };

    ElegantBox.prototype.popupRightNav = function (e) {
        e = e || window.event;

        if (this.currentImageIndex == this.album.length - 1)
            this.currentImageIndex = 0;
        else
            this.currentImageIndex = this.currentImageIndex + 1;

        this.preloadNeighboringImage(this.currentImageIndex);
        return false;
    };

    ElegantBox.prototype.resetBodyCSS = function () {
        $('body').animate('opacity', 1.0).css({
            'position': 'relative',
            'overflow': 'auto'
        });
    };

    ElegantBox.prototype.disableKeyboardNavigation = function () {
        $(document).off('click', '.elegant-left-nav');
        $(document).off('click', '.elegant-right-nav');
        $(document).off('keydown');
    };

    ElegantBox.prototype.enableKeyboardNavigation = function () {
        var self = this;
        $(document).on('keydown', function (e) {
            e = e || window.event;

            if (e.keyCode == '37') {
                // left arrow
                if ($('.elegant-wrapper').length > 0) {
                    self.popupLeftNav(e);
                }
            }
            else if (e.keyCode == '39') {
                // right arrow
                if ($('.elegant-wrapper').length > 0) {
                    self.popupRightNav(e);
                }
            }
            else if (e.keyCode == '27') {
                // escape button
                if ($('.elegant-wrapper').length > 0) {
                    self.destroy();
                }
            }
            return false;
        });

        $(document).on('click', '.elegant-right-nav', function (e) {
            self.popupRightNav(e);
            return false;
        });

        $(document).on('click', '.elegant-left-nav', function (e) {
            self.popupLeftNav(e);
            return false;
        });
    };

    ElegantBox.prototype.destroy = function () {
        var self = this;
        $('.elegant-right-nav, .elegant-left-nav, .elegant-caption')
            .css('display', 'none');

        $('.elegant-image').fadeOut(300, function () {
            self.resetBodyCSS();
            $('.elegant-wrapper').fadeOut().remove();
        });
        self.disableKeyboardNavigation();
    };

    ElegantBox.prototype.init = function (selector) {
        var self = this;

        if (self.album.length < 1) {
            self.addToAlbum($(selector));
        }

        //register events for newly added DOM elements
        selector.find('.elegant-popup').on('click', function (e) {

            var imageSrc = $(this).attr('src').split('/').slice(-1)[0].split('?')[0];
            self.currentImageIndex = self.album.findIndex(x => {
                if (x.src) {
                    return x.src.split('/').slice(-1)[0].split('?')[0] === imageSrc
                    } 
                }
            );


            self.enableKeyboardNavigation();

            self.image = new Image();
            self.image.onload = function () {
                self.image.height = this.height;
                self.image.width = this.width;
            };
            self.image.onerror = function () {
                alert("Image couldn't load.");
            };

            if (self.options.changePath) {
                self.elegantImage.attr('src', $(this).parent('a').attr('rel'));
            } else {
                self.elegantImage.attr('src', self.image.src);
            }

            self.image.title = undefined;
            if ($(this).attr('title') !== undefined) {
                self.image.title = $(this).attr('title');
            } else {
                self.image.title = undefined;
            }

            if (self.image.title !== '') {
                self.elegantImage.attr('title', self.image.title);
            }

            self.build(e, self.elegantImage, selector);
            return false;
        });

        $(document).on('click', '.elegant-close', function () {
            self.resetBodyCSS();
            $(this).parent().remove();
            self.disableKeyboardNavigation();
        });

        //register close for click outside of popup image
        $(document).on("mouseover", ".elegant-image, .elegant-left-nav, .elegant-right-nav", function () {
            self.mouseIsInside = true;
        });

        $(document).on("mouseout", ".elegant-image, .elegant-left-nav, .elegant-right-nav", function () {
            self.mouseIsInside = false;
        });

        $(document).on('click', '.elegant-inner', function () {
            if (self.mouseIsInside === false) {
                self.destroy();
            }
            return false;
        });
    };
}(jQuery));